export default "__VITE_ASSET__BHaddRej__"